import Flow from 'types/Flow';
import { SelfServiceSteps } from 'modules/selfServices/types/SelfServiceSteps';

import { FINAL_INVOICE, SUMMARY } from '../common';
import { MOBILITY_PARKING as COMMON_MOBILITY_PARKING, PARKING } from '../onSite';

export type CommonKioskCheckOutSteps =
  SelfServiceSteps.SUMMARY
  | SelfServiceSteps.FINAL_INVOICE
  | SelfServiceSteps.PARKING;

const COMMON_KIOSK_CHECK_OUT_STEPS: Flow<CommonKioskCheckOutSteps> = {
  SUMMARY,
  FINAL_INVOICE,
  PARKING: {
    ...PARKING,
    next: COMMON_MOBILITY_PARKING.key,
  },
};

export default COMMON_KIOSK_CHECK_OUT_STEPS;
